import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutParentView = _resolveComponent("LayoutParentView")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_main = _resolveComponent("el-main")!

  return (_openBlock(), _createBlock(_component_el_main, { class: "layout-main" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        class: "layout-scrollbar",
        ref: "layoutScrollbarRef",
        style: _normalizeStyle({
				minHeight: `calc(100vh - ${_ctx.headerHeight}`,
				padding: _ctx.currentRouteMeta.isLink && _ctx.currentRouteMeta.isIframe ? 0 : '',
				transition: 'padding 0.3s ease-in-out',
			})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_LayoutParentView),
          (_ctx.getThemeConfig.isFooter)
            ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}